<template>
  <div class="box">
    <div class="addTo" @click="filterGoTo">
      <i class="icon icon-addTo"></i><span>添加常用游客</span>
    </div>
    <ul>
      <li v-for="item in usefulPersonInfos" :key="item.id" v-watermark="{ text:item.certTypeName }">
        <div class="content">
          <div class="item">
            <span>姓名</span>
            <div class="text">
              <div class="tourist-info">
                <span class="owt1">{{ item.name }}</span>
                <i class="tag" :class="{ 'dim': item.tag === 'un_set' }">{{ item.tagName }}</i>
              </div>
              <i @click="upItem(item)" class="icon icon-hook"></i>
            </div>
          </div>
          <div class="item">
            <span>证件</span>
            <div class="text">
              <span class="owt1">{{ item.certNo }}</span>
              <i @click="deleteItem(item)" class="icon icon-fork"></i>
            </div>
          </div>
        </div>
      </li>
    </ul>
    <selectpopup v-if="popupstate" @onselectpopup="onselectpopup" title="删除常用游客" content="是否确定要删除 ？"/>
  </div>
</template>

<script>
import { getUsefulPersonDelPerson, getUsefulPerson } from "@/service/oftencontact/oftencontactList.js";

export default {
  name: "userOftenContactsList",
  data() {
    return {
      usefulPersonInfos: [],
      popupstate: false,
      currentItem: null,
      touristAllowance: {
        id_cardAllowance: 0,
        foreigNationalityAllowance: 0
      },
    }
  },
  created(){
    this.getDataInfo();
  },
  methods:{
    async getDataInfo(){
      const { data } = await getUsefulPerson({
        userId: JSON.parse(window.localStorage.getItem('userInfo')).userId
      });
      this.usefulPersonInfos = this.$fillTouristInfo(data.usefulPersonInfos);
      this.touristAllowance.id_cardAllowance = this.usefulPersonInfos.filter(v => v.certType === 'id_card').length;
      this.touristAllowance.foreigNationalityAllowance = this.usefulPersonInfos.length - this.touristAllowance.id_cardAllowance;
    },
    upItem(item){
      sessionStorage.setItem('userOftenconaddTouristItem', JSON.stringify(item));
      this.$router.push(`/userOftenconaddTourist?idcardallowance=${this.touristAllowance.id_cardAllowance}&foreignnationalityallowance=${this.touristAllowance.foreigNationalityAllowance}`);
    },
    deleteItem(item){
      this.currentItem = item;
      this.popupstate = true;
      this.$beyondHiding(true);
    },
    async onselectpopup(state){
      if(state === 'determine'){
        const data = await getUsefulPersonDelPerson({
          id:this.currentItem.id,
          userId: JSON.parse(window.localStorage.getItem('userInfo')).userId
        });
        if(data.status === "0"){
          this.$toast('删除游客成功');
          const deleteIndex = this.usefulPersonInfos.findIndex(item => item.id === this.currentItem.id);
          this.usefulPersonInfos.splice(deleteIndex, 1);
          const { certType } = this.currentItem;
          certType === 'id_card' ? this.touristAllowance.id_cardAllowance -- : this.touristAllowance.foreigNationalityAllowance --;
        }
      }
      this.popupstate = false;
      this.$beyondHiding(false);
    },
    filterGoTo(){
      if(this.touristAllowance.id_cardAllowance >= process.env.VUE_APP_MAX_NUMBER_VISITORS && this.touristAllowance.foreigNationalityAllowance >= process.env.VUE_APP_MAX_NUMBER_VISITORS)return this.$toast('常用游客已达人数上限，无法再添加');
      const userOftenconaddTouristItem = sessionStorage.getItem('userOftenconaddTouristItem');
      userOftenconaddTouristItem && sessionStorage.removeItem('userOftenconaddTouristItem');
      this.$router.push(`/userOftenconaddTourist?idcardallowance=${this.touristAllowance.id_cardAllowance}&foreignnationalityallowance=${this.touristAllowance.foreigNationalityAllowance}`);
    },
  }
};
</script>

<style scoped lang='less'>
.box{
  padding: 0.373333rem 0;
  .addTo{
    font-size: .24rem * 2;
    color: #FFFFFF;
    line-height: .64rem * 2;
    background: #3B6D9C;
    border-radius: .16rem;
    margin: 0 .346667rem;
    display: flex;
    align-items: center;
    justify-content: center;
    i{
      width: .24rem * 2;
      height: .24rem * 2;
      margin-right: .5em;
    }
  }
  ul{
    font-size: .373333rem;
    li{
      padding: 0 .346667rem;
      margin: .373333rem .346667rem 0;
      background: #FFFFFF;
      border-radius: .16rem;
      display: flex;
      align-items: center;
      & > i{
        width: .213333rem * 2;
        height: .213333rem * 2;
      }
      & > .checkMark{
        background: #0078D7 url('~@/assets/image/common/common_icon.png') no-repeat ~'-4.92rem 0.11rem / 9.8rem 3rem';
      };
      & > .fork{
        border: 1px solid #A1A6BA;
      }
      .content{
        padding: .213333rem 0 .213333rem .346667rem;
          flex: 1;
        .item{
          display: flex;
          &:last-child{
            margin-top: .32rem;
          }
          & > span{
            min-width: 4em;
            margin-right: 1em;
            color: rgba(58, 62, 92, .8);
          }
          .text{
            flex: 1;
            display: flex;
            align-items: center;
            justify-content: space-between;
            .tourist-info{
              display: flex;
              align-items: center;
              span{
                max-width: 11em;
              }
              .tag{
                min-width: .8rem;
                height: .373333rem;
                background: #F1F5F8;
                border-radius: .186667rem;
                font-size: .24rem;
                color: #3B6D9C;
                line-height: .373333rem;
                text-align: center;
                padding: 0 .16rem;
                white-space: nowrap;
                margin-left: .066667rem;
              }
              .dim{
                background: #D8D8D8;
                color: #666666;
              }
            }
            & > i{
              width: .173333rem * 2;
              height: .173333rem * 2;
            }
          }
        }
      }
    }
  }
  .selected{
    position: fixed;
    bottom: .666667rem;
    display: flex;
    width: 100%;
    line-height: 1.333333rem;
    padding: 0 .4rem;
    div{
      flex: 1;
      border-radius: .16rem;
      text-align: center;
      font-size: .24rem * 2;
      color: #FFFFFF;
    }
    .cancel{
      background: #A1A6BA;
      margin-right: .32rem;
    }
    .determine{
      background: #3B6D9C;
    }
  }
}
</style>
